/* eslint-env browser */
import { GET_ITEM } from './const';

const actionCreators = {
  getItem: (id) => async (dispatch) => {
    const getData = async () => {
      const url = `https://webtools.au.dk/api/bachelor/getitem?id=${id}`;
      const response = await fetch(url, {
        method: 'GET',
        mode: 'cors',
      });
      const result = await response.json();
      dispatch({ type: GET_ITEM, result });
    };

    getData();
  },
};

export default actionCreators;
